import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-info-estado-situacion',
  templateUrl: './info-estado-situacion.component.html',
  styleUrls: ['./info-estado-situacion.component.scss']
})
export class InfoEstadoSituacionComponent implements OnInit {
  @Input() title: string;
  @Output() nextComponent = new EventEmitter();
  buttonComenzar = {
    text: 'COMENZAR',
    class: 'btn-primary',
    type: 'button'
  };

  constructor(private readonly analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.analyticsService.pageView({
      screen_name: 'estado de situacion :: login'
    });
  }
  cambiarFormulario() {
    this.analyticsService.btnClick({
      label: 'comenzar',
      action: 'click',
      channel: 'browser',
      element_id: undefined,
      type: 'button',
      section: 'inicio'
    });
    this.nextComponent.emit(true);
  }
}
